import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import {
    setCaptchaV3StatusAction,
    setCaptchaV3TokenAction,
    setIsCaptchaV3TimeoutReachedAction,
} from '../../actions/app';
import { CaptchaStatus } from '../../models/app';
import { getCaptchaSettings } from '../../selectors/app';
import { getIsCustomerPurchaseFlow } from '../../selectors/app/getIsCustomerPurchaseFlow';
import { getHasPromoCode } from '../../selectors/event';
import { isRecaptchaV3Enabled } from '../../selectors/splitio';
import {
    getHasTicketsWithPromoCodeApplied,
    hasFreeTickets,
} from '../../selectors/tickets';
import { CheckoutState } from '../../state';
import { ReCaptchaV3Props } from './ReCaptchaV3';

type ConnectedPropsFromState = Pick<
    ReCaptchaV3Props,
    'captcha' | 'enabledReCaptchaV3'
>;

const mapStateToProps = (state: CheckoutState): Partial<ReCaptchaV3Props> => ({
    captcha: getCaptchaSettings(state),
    enabledReCaptchaV3:
        isRecaptchaV3Enabled(state) &&
        getIsCustomerPurchaseFlow(state) &&
        (hasFreeTickets(state) ||
            getHasPromoCode(state) ||
            getHasTicketsWithPromoCodeApplied(state)),
});

type ConnectedPropsFromDispatch = Pick<
    ReCaptchaV3Props,
    'setCaptchaV3Token' | 'setCaptchaV3Status' | 'setTimeoutReached'
>;

const mapDispatchToProps = (
    dispatch: Dispatch<CheckoutState>,
): ConnectedPropsFromDispatch => ({
    setCaptchaV3Token: (token: string) =>
        dispatch(setCaptchaV3TokenAction(token)),
    setCaptchaV3Status: (status: CaptchaStatus) =>
        dispatch(setCaptchaV3StatusAction(status)),
    setTimeoutReached: (isReached: boolean) =>
        dispatch(setIsCaptchaV3TimeoutReachedAction(isReached)),
});

export type ConnectedProps = ConnectedPropsFromState &
    ConnectedPropsFromDispatch;

const connectReCaptchaV3 = connect(mapStateToProps, mapDispatchToProps);

export default connectReCaptchaV3;
